export default __webpack_public_path__ + "static/media/definix-token.342c4376.png";